import Skeleton from "./Skeleton";

interface SidebarGroup {
  items: number;
}

const SIDEBAR_GROUPS: SidebarGroup[] = [
  { items: 4 },
  { items: 1 },
  { items: 1 },
  { items: 2 },
  { items: 1 },
];

const PROGRESS_ROWS = 5;
const CONTACT_ROWS = 3;

export default function GcProjectDetailSkeleton() {
  return (
    <div style={{ minHeight: "100vh", background: "#f5f6f8" }}>
      {/* Project Banner */}
      <div
        style={{
          background: "linear-gradient(135deg, #1a3d6b 0%, #2563eb 100%)",
          padding: "18px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Skeleton
            width={220}
            height={18}
            style={{ background: "rgba(255,255,255,0.2)" }}
          />
          <div style={{ display: "flex", gap: 16 }}>
            <Skeleton
              width={130}
              height={12}
              style={{ background: "rgba(255,255,255,0.15)" }}
            />
            <Skeleton
              width={110}
              height={12}
              style={{ background: "rgba(255,255,255,0.15)" }}
            />
            <Skeleton
              width={90}
              height={12}
              style={{ background: "rgba(255,255,255,0.15)" }}
            />
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Skeleton
            width={80}
            height={24}
            borderRadius={20}
            style={{ background: "rgba(255,255,255,0.2)" }}
          />
          <Skeleton
            width={140}
            height={8}
            borderRadius={4}
            style={{ background: "rgba(255,255,255,0.2)" }}
          />
        </div>
      </div>

      {/* Body */}
      <div style={{ display: "flex", minHeight: "calc(100vh - 104px)" }}>
        {/* Sidebar */}
        <aside
          style={{
            width: 200,
            flexShrink: 0,
            background: "#fff",
            borderRight: "1px solid #e5e7eb",
            padding: "16px 0",
          }}
        >
          {SIDEBAR_GROUPS.map((group, g) => (
            <div key={g} style={{ marginBottom: 16 }}>
              <div style={{ padding: "0 14px 8px" }}>
                <Skeleton width={60} height={10} />
              </div>
              {Array.from({ length: group.items }).map((_, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "9px 14px",
                  }}
                >
                  <Skeleton width={16} height={16} borderRadius={4} />
                  <Skeleton width={100} height={13} />
                </div>
              ))}
            </div>
          ))}
        </aside>

        {/* Main content */}
        <div
          style={{
            flex: 1,
            padding: "24px 28px",
            display: "flex",
            flexDirection: "column",
            gap: 16,
            minWidth: 0,
          }}
        >
          {/* Alert banners */}
          {[1, 2].map((i) => (
            <div
              key={i}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                padding: "16px 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: "#fff",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <Skeleton width={280} height={14} />
                <Skeleton width={420} height={12} />
              </div>
              <Skeleton width={120} height={34} borderRadius={6} />
            </div>
          ))}

          {/* Metrics strip — 4 cards */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 14,
            }}
          >
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                style={{
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  padding: "14px 16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}
              >
                <Skeleton width={90} height={11} />
                <Skeleton width={110} height={22} />
                <Skeleton width={70} height={11} />
              </div>
            ))}
          </div>

          {/* Two-column: Progress + Contacts */}
          <div
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}
          >
            {/* Construction Progress */}
            <div
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                padding: "18px 20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 18,
                }}
              >
                <Skeleton width={160} height={14} />
                <Skeleton width={120} height={12} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 14 }}
              >
                {Array.from({ length: PROGRESS_ROWS }).map((_, i) => (
                  <div
                    key={i}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "100px 1fr 36px",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <Skeleton width={80} height={12} />
                    <Skeleton width="100%" height={8} borderRadius={4} />
                    <Skeleton width={30} height={12} />
                  </div>
                ))}
              </div>
            </div>

            {/* Key Contacts */}
            <div
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                padding: "18px 20px",
              }}
            >
              <Skeleton width={100} height={14} style={{ marginBottom: 18 }} />
              <div
                style={{ display: "flex", flexDirection: "column", gap: 18 }}
              >
                {Array.from({ length: CONTACT_ROWS }).map((_, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 12 }}
                    >
                      <Skeleton width={38} height={38} borderRadius="50%" />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 6,
                        }}
                      >
                        <Skeleton width={120} height={13} />
                        <Skeleton width={160} height={11} />
                      </div>
                    </div>
                    <Skeleton width={70} height={12} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
